import { useLocation } from "react-router-dom";
import { getRouteSchema } from "./routeSeo";

const JSONLD_ID = "seo-route-jsonld";

export function JsonLd() {
  const { pathname } = useLocation();

  useEffect(() => {
    const existing = document.getElementById(JSONLD_ID);
    if (existing) {
      existing.remove();
    }

    const schema = getRouteSchema(pathname);
    if (!schema) {
      return;
    }

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = JSONLD_ID;
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }, [pathname]);

  return null;
}